import axios from "axios";
import { fetchApiData, fetchApiDataV2, updateApiDataV2,commentImageUpload,commentGifUpload } from "../../utils/utils";

export const getVideoDetails = async (appInfo,id,showId) =>{
    const api =`video/details/${id}`
    // if(appInfo?.projectDetails?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED==="true"){
    //     return await fetchApiDataV2(appInfo,api)
    // }else{
    //     return await fetchApiDataV2(appInfo,api)
    // }
   const params = showId ? { show_id: showId } : null
    return await fetchApiDataV2(appInfo,api,params)
}

export const getLiveInfo = async (appInfo)=>{
    const api="channel/list"
    if(appInfo?.projectDetails?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED==="true"){
        return await fetchApiData(appInfo,api)
    }else{
        return await fetchApiData(appInfo,api)
    }
    
  }
 export const commentImageUploadThumbnail = async (data,appInfo) =>{
    const api =`comments/image`
  
    return await commentImageUpload(data,appInfo,api)
  }
  export const commentGifUploadThumbnail = async (data,appInfo) =>{
    const api =`comments/gif`
  
    return await commentGifUpload(data,appInfo,api)
  }
